<template>
  <v-flex
    column
    role="region"
    aria-label="Events content"
  >
    <!-- Decorative parallax with accessible description -->
    <v-parallax
      src="https://gm.goz.fun/wp-content/uploads/2023/03/events-cover.png"
      height="350"
      role="img"
      aria-label="Events section banner with themed illustration"
    />

    <v-card
      flat
      role="region"
      aria-label="Events listing content"
    >
      <v-layout
        column
        pb-2
        role="presentation"
      >
        <v-flex
          xs12
          sm12
          md12
          lg8
          justify-center
        >
          <!-- Accessible search component -->
          <search
            subject="events"
            :limit="limit"
            aria-label="Search events"
            @onChangedText="onSearchChange"
          />

          <!-- Posts list with ARIA title -->
          <posts
            :posts="posts"
            :title="$t('components.events.title')"
            :is-loading="isLoading"
            aria-label="Filtered list of events"
          />
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>


<script>
import { toPaginatedPosts, searchPost } from "@/utils/post.utils";

export default {
  name: "EventsLayout",
  components: {
    Posts: () => import("@/components/Views/Posts.vue"),
    Search: () => import("@/components/Views/Search.vue"),
  },
  data() {
    return {
        apiEvents: [],
        searchText: "",
        limit: 100,
        isLoading: true,
    }
  },
  computed: {
      posts() {
          return this.searchText
            ? toPaginatedPosts(searchPost(this.apiEvents, this.searchText), "")
            : toPaginatedPosts(this.apiEvents, this.$route.query.slug);
      }
  },
  watch: {
      posts() {
        this.isLoading = false;
      }
  },
  async mounted() {
    this.apiEvents = await this.$api.getEvents(this.limit);
  },
  methods: {
    async onSearchChange(searchText) {
        this.isLoading = true;
        this.searchText = searchText;
    }
  }
};
</script>
